import React from 'react';
export const getTestId = (testId)=>testId !== null && testId !== void 0 ? testId : 'split-button';
